import React, { useRef, useState } from 'react';
import { useClickOutside } from '../../hooks';
import { AngleDownIcon } from '../../helpers/icons';

export const Dropdown = ({
  children,
  shouldCloseOnClickOutside = true,
  CaretComponent = AngleDownIcon,
  showcaret = true,
  headerComponent = null,
  footerComponent = null,
  extraClasses = '',
  options = [],
  RenderItem = ({ item }) => <div className="p--sm">{item?.label}</div>,
}) => {
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);
  useClickOutside(
    dropdownRef,
    () => shouldCloseOnClickOutside && setShow(false),
  );

  return (
    <dropdown-element
      dropdown-element
      ref={dropdownRef}
      onClick={(e) => {
        const targetTag = e?.target?.tagName?.toLowerCase?.();
        const isInputClick = targetTag === 'input' || targetTag === 'textarea';

        // Let inputs be focusable/typable; clicking the input should open (not toggle/close).
        if (isInputClick) {
          setShow(true);
          return;
        }

        setShow((prev) => !prev);
      }}
    >
      {children}
      <dropdown-caret dropdown-caret>
        {showcaret && <CaretComponent width={15} />}
      </dropdown-caret>
      {show && (
        <dropdown-menu
          ref={dropdownRef}
          id="dropdown-menu-elm"
          dropdown-menu
          className={`${extraClasses} top--100`}
        >
          {headerComponent ? (
            <dropdown-header>{headerComponent}</dropdown-header>
          ) : (
            <></>
          )}
          <dropdown-menu-body dropdown-menu-body>
            {options.map((item, index) => {
              const { access = true, isDisabled = false, cb = () => {} } = item;
              if (!access) return <React.Fragment key={index}></React.Fragment>;
              return (
                <dropdown-menu-item
                  dropdown-menu-item
                  key={index}
                  disabled={isDisabled}
                  onClick={() => cb()}
                >
                  <RenderItem item={item} key={index} />
                </dropdown-menu-item>
              );
            })}
          </dropdown-menu-body>
          {footerComponent ? (
            <dropdown-footer>{footerComponent}</dropdown-footer>
          ) : (
            <></>
          )}
        </dropdown-menu>
      )}
    </dropdown-element>
  );
};
